// SPDX-License-Identifier: AGPL-3.0-or-later

// The Pioneerchat desktop app hides "Electron/…" from its user agent (so the
// web app doesn't think it is Fluxer's own desktop build) and adds
// "PioneerchatDesktop/<version>" instead.
export function isInsidePioneerchatDesktop(): boolean {
	return typeof navigator !== 'undefined' && /\b(?:PioneerchatDesktop|Electron)\//.test(navigator.userAgent);
}
